import { render, staticRenderFns } from "./PersonGroupList.vue?vue&type=template&id=58e848b7&scoped=true&"
import script from "./PersonGroupList.vue?vue&type=script&lang=js&"
export * from "./PersonGroupList.vue?vue&type=script&lang=js&"
import style0 from "./PersonGroupList.vue?vue&type=style&index=0&id=58e848b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e848b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e848b7')) {
      api.createRecord('58e848b7', component.options)
    } else {
      api.reload('58e848b7', component.options)
    }
    module.hot.accept("./PersonGroupList.vue?vue&type=template&id=58e848b7&scoped=true&", function () {
      api.rerender('58e848b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/Person/PersonGroupList.vue"
export default component.exports